import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,-4.99999828e-08 C1490.19336,-4.99999828e-08 1920,429.80664 1920,960 C1920,1490.19336 1490.19336,1920 960,1920 C429.80664,1920 0,1490.19336 0,960 C0,429.80664 429.80664,-4.99999828e-08 960,-4.99999828e-08 Z M960,106.666667 C488.717014,106.666667 106.666667,488.717013 106.666667,960 C106.666667,1431.28299 488.717014,1813.33333 960,1813.33333 C1431.28299,1813.33333 1813.33333,1431.28299 1813.33333,960 C1813.33333,488.717013 1431.28299,106.666667 960,106.666667 Z M960,330.666672 C1307.07733,330.666672 1589.33333,613.080003 1589.33333,960 C1589.33333,1307.07733 1307.07733,1589.33333 960,1589.33333 C612.92267,1589.33333 330.666672,1307.07733 330.666672,960 C330.666672,613.080003 612.92267,330.666672 960,330.666672 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRecordLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRecordLine, _Component);

  var _super = _createSuper(IconRecordLine);

  function IconRecordLine() {
    _classCallCheck(this, IconRecordLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRecordLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRecord",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRecordLine.displayName = "IconRecordLine";
  return IconRecordLine;
}(Component);

IconRecordLine.glyphName = 'record';
IconRecordLine.variant = 'Line';
IconRecordLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRecordLine;
export { IconRecordLine };